module.exports = __webpack_public_path__ + "img/icon_wechat.698fc477.png";